translate =
	general: 'Модель сервера'
	channels: 'Безлимитный Интернет'
	antiDdos: 'Защита от DDoS-атак'
	dopIP: 'Дополнительный IP'
	ip: 'IP Адрес'
	units: 'Юниты'
	power: 'Мощность'
	os: 'Система'
	abonCost: 'Месячная плата'
	installCost: 'Установочная плата'

units =
	ram: 'GB'
	hdd: 'GB'
	cpu: 'Ядер'
	channels: 'Mbit/s'

types =
	order:
		title: 'Оформление заказа'
		button: 'Оформить заказ'
	contactUs:
		title: 'Связаться с нами'
		button: 'Отправить'
		descrip: 'Оставьте заявку и наши менеджеры обязательно свяжутся с вами'

order = [
	'models_servers'
	'cpu'
	'ram'
	'hdd'
	'power'
	'channels'
	'antiDdos'
	'raid'
	'additional'
	'os'
	'ip'
]

class Modal
	constructor: (data) ->
		data = data || {}

		@selectors =
			overlay: '.overlay-modal'
			modal: '.modal-box'
			close: '.close'

		@init data

	init: (data) =>
		$overlay = $ @selectors.overlay

		if data.action is 'order'
			data.translate = translate
			data.units = units
			data.source = data.source || configs

		data.page = @pageData()
		if data.action of types
			data.modal = types[data.action]
			data.modal.descrip = data.page.service unless data.modal.descrip

		@orderRactive = new Ractive
			magic: true
			el: $overlay
			template: Ractive.parse $overlay.html()
			data: data

		@$el = $ @orderRactive.el
		$modal = @$el.find @selectors.modal
		$close = $modal.find @selectors.close

		@elements =
			overlay: $overlay
			modal: $modal
			close: $close

		@elements.overlay.on 'click', @overlayClick
		@elements.close.on 'click', @hide

		@orderRactive.on 'nextStep', @nextStep

	pageData: =>
		data = {}
		$title = $ '.heading-described'
		data.service = $title.text() if $title.length > 0
		data.options = options if options?

		data

	modal: =>
		current = @orderRactive.get 'current'
		@orderRactive.set 'current', sortObject current, order if current?

		$body = $ 'body'

		$body.addClass 'overlayHidden'

		@orderRactive.set 'step', 1

		$validateForm = @$el.find 'form.validate:not([novalidate]):first'
		@parsley = $validateForm.parsley() if $validateForm.length

		@elements.overlay.fadeIn()

		@orderRactive.update()

	nextStep: =>
		step = @orderRactive.get 'step'
		action = @orderRactive.get 'action'
		isValid = if @parsley then @parsley.validate() else true

		if step is 1 and isValid
			send =
				credential: @orderRactive.get 'credential'
				service: @orderRactive.get 'page.service'
				action: action

			if action is 'order' and _.isObject @orderRactive.get 'current'
				send.current = _.cloneDeep @orderRactive.get 'current'
				send.current.total = _.sum @orderRactive.get 'total'
				source = @orderRactive.get 'source' if @orderRactive.get 'source'

				delete send.current.raid if send.current.raid?

				for currentKey of send.current
					isAboncost = currentKey is 'aboncost'
					isGeneral = currentKey is 'general'

					sourceItem = if isGeneral then configs else source[currentKey]

					isConfiguration = _.isPlainObject(sourceItem) and _.has sourceItem, 'id'

					continue unless isConfiguration or not isAboncost or _.isArray sourceItem
					currentItem = send.current[currentKey]

					if _.isArray sourceItem
						if _.isArray currentItem
							for currentConfig, index in currentItem
								sourceConfig = sourceItem[currentConfig]
								continue unless _.has sourceConfig, 'id'
								currentItem[index] =
									id: sourceConfig.id

						isQuantityItem = _.has currentItem, 'quantity'
						currentItemIndex = if _.has currentItem, 'i' then currentItem.i else currentItem
						sourceConfig = sourceItem[currentItemIndex]

						continue unless _.isPlainObject sourceConfig

						if isQuantityItem
							quantity = send.current[currentKey].quantity

						send.current[currentKey] =
							id: sourceConfig.id
						send.current[currentKey].quantity = quantity if isQuantityItem

					else if _.has currentItem, 'required'
						send.current[currentKey] =
								id: source[currentKey].id

					else if _.isBoolean currentItem
						if currentItem
							send.current[currentKey] =
								id: sourceItem.id

			$.post themeurl + '/order.php', send

		@orderRactive.add 'step' if isValid

	overlayClick: (e) =>
		$target = $ e.target
		return if $target.hasClass 'order'
		closets = $target.closest(@selectors.modal).length
		@hide() unless closets

	hide: =>
		$body = $ 'body'
		$body.removeClass 'overlayHidden'

		@elements.overlay.fadeOut()

module.exports = Modal


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/modal.coffee
 **/